import React, { useEffect, useState } from "react";
import { Alert, Row, Col, Modal, Checkbox, Radio } from 'antd';
import Mispichoshelper from "../../../utils/Mispichoshelper";
import { set } from "react-ga";


const confirm = Modal.confirm;


export default function Refund({ compra, hideReembolso, showReembolso, refrescarCompra, forceMotive = null, hideFromWizard = null }) {

    const [loading, setLoading] = useState(false)
    const [motivSelect, setMotiv] = useState(forceMotive)
    const [observaciones, setObs] = useState("")
    const [motivos, setMotivos] = useState([])
    const [notMakeRefund, setNotMakeRefund] = useState(false)
    const [refundType, setRefundType] = useState('gateway')
    const [sendNotification, setSendNotification] = useState(true)

    useEffect(() => {
        Mispichoshelper.getMotivosCompraCancelaciones().then(response => setMotivos(response.payload));
    }, [])

    const cancelaCompra = () => {

        var params = {
            observaciones: observaciones,
            motivo_id: motivSelect,
            'compra_id': compra.compra_id,
            not_make_refund: notMakeRefund,
            refund_type: refundType,
            send_notification: sendNotification,
        };
        Mispichoshelper.postCancelaCompra(params).then(informaResponse);
    }

    const informaResponse = (response) => {
        refrescarCompra(compra.compra_id);
        if (response && response.status) {
            confirm({
                title: response.payload.message,
                content: 'Datos guardados satisfactoriamente',
                onOk: () => hideFromWizard ? hideFromWizard() : hideReembolso('reembolso', false)
            });
        } else if (response && response.payload && response.payload.message) {
            Modal.error({
                title: "Ocurrio un Error",
                content: response.payload.message,
            });
        } else {
            Modal.error({
                title: "Ocurrio un Error",
                content: 'No pudimos cancelar la compra',
            });
        }
    }

    const buildConfirmMessage = () => {
        if (notMakeRefund) {
            return `No se generará reembolso para la compra de ${compra.compra_cliente}.` +
                (sendNotification ? ' Se notificará al cliente.' : ' No se enviará notificación al cliente.')
        }

        if (compra.compra_medio_pago === 'tarjeta') {
            const refundMsg = refundType === 'picho_pesos'
                ? `Se acreditarán $${compra.compra_total} en Picho Pesos en la cuenta de ${compra.compra_cliente}.`
                : `Se generará un reembolso de $${compra.compra_total} por pasarela de pago para ${compra.compra_cliente}.`
            const notifMsg = sendNotification ? ' Se notificará al cliente.' : ' No se enviará notificación al cliente.'
            return refundMsg + notifMsg
        }

        const notifMsg = sendNotification ? ' Se notificará al cliente.' : ' No se enviará notificación al cliente.'
        return `La compra fue realizada en efectivo, no hay reembolso a procesar.` + notifMsg
    }

    const handleOk = () => {
        if (observaciones !== "") {
            confirm({
                title: '¿Confirmás la cancelación de la compra?',
                content: buildConfirmMessage(),
                onOk: () => cancelaCompra()
            });
        } else {
            Modal.error({
                title: "Por favor completa el campo de observaciones",
            });
        }
    }

    const generateTextAlert = () => {
        if (compra.compra_medio_pago === 'tarjeta') {

            if (notMakeRefund) {
                return "Está seleccionada la opción de no generar reembolso." +
                    "No se generará reembolso por el monto de $" + compra.compra_total + " sobre la compra del Cliente " + compra.compra_cliente + "." +
                    "Esto es para casos especiales y debes tener los permisos correspondientes para hacerlo."
            }

            if (refundType === 'picho_pesos') {
                return "Se acreditarán $" + compra.compra_total + " en Picho Pesos en la cuenta del cliente " + compra.compra_cliente + "."
            }

            return "Se generera un reembolso total de $" + compra.compra_total + " sobre la compra del Cliente " + compra.compra_cliente + ", el mismo se vera reflejado es su proximo resumen."
        }
        return "La compra fue realizada en efectivo, no hay nada más que hacer Rick."
    }

    return (
        <Modal
            title="Advertencia"
            visible={showReembolso}
            onOk={handleOk}
            onCancel={() => hideFromWizard ? hideFromWizard() : hideReembolso('reembolso', false)}
        >
            <Row style={{ margin: 10 }}>
                <Col span={24}>
                    <Alert
                        message="Se Cancelará esta compra."
                        description={generateTextAlert()}
                        type={notMakeRefund ? "error" : "warning"}
                    />
                </Col>
            </Row>
            {compra.compra_medio_pago === 'tarjeta' &&
                <Row style={{ margin: 10 }}>
                    <Col span={24}>
                        <Checkbox
                            checked={notMakeRefund}
                            onChange={(e) => {
                                setNotMakeRefund(e.target.checked)
                                if (e.target.checked) setRefundType('gateway')
                            }}
                        >
                            No generar reembolso
                        </Checkbox>
                    </Col>
                </Row>
            }
            {compra.compra_medio_pago === 'tarjeta' && !notMakeRefund &&
                <Row style={{ margin: 10 }}>
                    <Col span={24}>
                        <strong>Tipo de reembolso: </strong>
                        <Radio.Group value={refundType} onChange={(e) => setRefundType(e.target.value)} style={{ marginTop: 8 }}>
                            <Radio value="gateway">Pasarela de pago</Radio>
                            <Radio value="picho_pesos">Picho Pesos</Radio>
                        </Radio.Group>
                    </Col>
                </Row>
            }
            <Row style={{ margin: 10 }}>
                <Col span={24}>
                    <Checkbox
                        checked={sendNotification}
                        onChange={(e) => setSendNotification(e.target.checked)}
                    >
                        Enviar notificación al cliente
                    </Checkbox>
                </Col>
            </Row>
            <Row style={{ margin: 10 }}>
                <Col span={24}>
                    <select
                        className='w100 MT1 '
                        onChange={(evt) => setMotiv(parseInt(evt.target.value))}
                        placeholder="Elige un motivo"
                        value={motivSelect}
                        required
                    >
                        <option value=''>Seleccionar</option>
                        {motivos.map((item, idx) => (
                            <option key={idx} value={item.id}>{item.nombre}</option>
                        ))}
                    </select>

                    <textarea style={{ width: '100%' }} rows="4" maxLength="140" onChange={(evt) => setObs(evt.target.value)} className="MT1">

                    </textarea>
                </Col>
            </Row>
        </Modal>
    )
}

